<template>
  <section class="services-full">
    <!-- Title -->
    <div class="services-full__title">
      {{ $t("services_1") }}
    </div>

    <!-- Subtitle -->
    <div class="services-full__subtitle">
      {{ $t("services_2_1") }}
    </div>

    <!-- Services -->
    <div class="services-full__content">
      <!-- Strategy -->
      <services-item-view variant="has-detail has-detail--right">
        <template slot="icon">
          <icon-service-strategy-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_3") }}
        </template>

        <template slot="content">
          {{ $t("services_7") }}
        </template>
      </services-item-view>

      <!-- UX -->
      <services-item-view variant="has-detail has-detail--bottom">
        <template slot="icon">
          <icon-service-ux-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_4") }}
        </template>

        <template slot="content">
          {{ $t("services_8") }}
        </template>
      </services-item-view>

      <!-- UI -->
      <services-item-view variant="has-detail has-detail--top">
        <template slot="icon">
          <icon-service-ui-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_5") }}
        </template>

        <template slot="content">
          {{ $t("services_9") }}
        </template>
      </services-item-view>

      <!-- Dev -->
      <services-item-view variant="has-detail has-detail--left">
        <template slot="icon">
          <icon-service-dev-view v-inview:class="['animate']" />
        </template>

        <template slot="title">
          {{ $t("services_6") }}
        </template>

        <template slot="content">
          {{ $t("services_10") }}
        </template>
      </services-item-view>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesFull',

  components: {
    ServicesItemView: () => import('./services-item-view'),
    IconServiceStrategyView: () => import('@/icons/icon-service-strategy-view'),
    IconServiceUxView: () => import('@/icons/icon-service-ux-view'),
    IconServiceUiView: () => import('@/icons/icon-service-ui-view'),
    IconServiceDevView: () => import('@/icons/icon-service-dev-view')
  },

  mounted() {}
};
</script>

<style
  lang="scss"
  src="@/assets/components/services/services-full-view.scss"
></style>



// WEBPACK FOOTER //
// services-full-view.vue